"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var FormComponent_1 = __importDefault(require("../../../../../../../../components/FormComponents/FormComponent"));
var CardRow = function (_a) {
    var rows = _a.rows, order = _a.order, name = _a.name, formikProps = _a.formikProps, post = _a.post, index = _a.index, mortgageId = _a.mortgageId, addRemovedMortgageId = _a.addRemovedMortgageId;
    return (react_1.default.createElement(react_1.default.Fragment, null, rows.map(function (row, i) {
        return (react_1.default.createElement("div", { className: "equal width row", key: i }, Object.keys(row).map(function (fieldName) {
            var field = row[fieldName];
            return (react_1.default.createElement(FormComponent_1.default, { key: fieldName, field: field, fieldName: fieldName, order: order, section: name, index: index, formikProps: formikProps, disabled: field.disabled, mortgageId: mortgageId, addRemovedMortgageId: addRemovedMortgageId }));
        })));
    })));
};
exports.default = CardRow;
